module.exports = __webpack_public_path__ + "static/media/covidlogo (1).dcdc4a5a.png";